import {Expose} from "class-transformer";
import {CommandPayload} from "./command-payload";
import type {SensitivePayload} from "./sensitive-payload.interface";

/**
 * Payload of `ChangeOwnEmailAddressCommand`: the new e-mail address and the current password, which
 * the backend checks. The password is an argument of this step, not a field of the user, so it
 * cannot travel in the `update.user` delta.
 *
 * The CommandBus keeps every dispatched command in its history for the session, so the password must
 * not stay on this object: the bus clears it right after the request body was built
 * (`clearSensitiveValues`), and the page clears it again once the command was answered.
 */
export class ChangeOwnEmailAddressContent extends CommandPayload implements SensitivePayload {

    @Expose()
    public emailAddress: string;

    @Expose()
    public currentPassword: string;

    public constructor(emailAddress: string, currentPassword: string) {
        super();
        this.emailAddress = emailAddress;
        this.currentPassword = currentPassword;
    }

    public clearSensitiveValues(): void {
        this.currentPassword = '';
    }
}
